module.exports = __webpack_public_path__ + "static/media/MuliBold.91fff299.woff";